import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage.userinfo');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage-userinfo',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage.userinfo/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMypageUserinfoComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;
    public view: 'edit_profile' | 'check_password' | 'change_password' = 'edit_profile';

    public info: any = {};
    public data: any = {
        password: '',
        change_password: '',
        change_password_re: ''
    };
    public role: string | null = null;
    public ready = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow(true, "/auth/login");
        if (!allowed) return;
        const authSession = this.service.auth?.session ?? {};
        this.role = (authSession.role ?? '').toString().toLowerCase() || null;
        await this.load();
        this.ready = true;
        await this.service.render();
    }

    private async load() {
        const { code, data } = await wiz.call('userinfo');
        if (code === 200) {
            this.info = data;
        }
    }

    private showModal(message): Promise<boolean> {
        return this.modalMessage.open({ message });
    }

    public async formatMobile() {
        if (!this.info.mobile) return;

        this.info.mobile = this.info.mobile
            .replace(/[^0-9]/g, '')
            .replace(
                /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
                '$1-$2-$3'
            )
            .replace('--', '-');

        await this.service.render();
    }

    public async changeView(view: any) {
        this.view = view;
        await this.service.render();
    }

    public async checkPassword() {
        const { data } = await wiz.call('check_password', {
            password: this.data.password
        });

        if (data) {
            this.view = 'change_password';
            await this.service.render();
            return;
        }

        await this.showModal('비밀번호가 틀렸습니다.');
    }

    public async updatePassword() {

        if (this.data.change_password.length < 8) {
            await this.showModal('8자 이상의 비밀번호를 입력해주세요.');
            return;
        }

        if (this.data.change_password !== this.data.change_password_re) {
            await this.showModal('비밀번호가 일치하지 않습니다.');
            return;
        }

        const { data } = await wiz.call('update_password', {
            password: this.data.password,
            change_password: this.data.change_password
        });

        if (data) {
            await this.showModal('비밀번호가 변경되었습니다. 다시 로그인해주세요.');
            location.href = '/auth/logout';
            return;
        }

        await this.showModal('비밀번호 변경에 실패하였습니다.');
    }

    public async updateProfile() {
        await wiz.call('update', this.info);
        await this.showModal('변경사항이 저장되었습니다.');
    }
}

export default PageMypageUserinfoComponent;